"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TapDetectionSettingsT = exports.TapDetectionSettings = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
class TapDetectionSettings {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsTapDetectionSettings(bb, obj) {
        return (obj || new TapDetectionSettings()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsTapDetectionSettings(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new TapDetectionSettings()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    fullResetDelay() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.readFloat32(this.bb_pos + offset) : null;
    }
    fullResetEnabled() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : null;
    }
    fullResetTaps() {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? this.bb.readUint8(this.bb_pos + offset) : null;
    }
    yawResetDelay() {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? this.bb.readFloat32(this.bb_pos + offset) : null;
    }
    yawResetEnabled() {
        const offset = this.bb.__offset(this.bb_pos, 12);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : null;
    }
    yawResetTaps() {
        const offset = this.bb.__offset(this.bb_pos, 14);
        return offset ? this.bb.readUint8(this.bb_pos + offset) : null;
    }
    mountingResetDelay() {
        const offset = this.bb.__offset(this.bb_pos, 16);
        return offset ? this.bb.readFloat32(this.bb_pos + offset) : null;
    }
    mountingResetEnabled() {
        const offset = this.bb.__offset(this.bb_pos, 18);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : null;
    }
    mountingResetTaps() {
        const offset = this.bb.__offset(this.bb_pos, 20);
        return offset ? this.bb.readUint8(this.bb_pos + offset) : null;
    }
    /**
     * If true, disables reset behavior of tap detection and sends a
     * TapDetectionSetupNotification, each time 2 taps are detected on any tracker
     */
    setupMode() {
        const offset = this.bb.__offset(this.bb_pos, 22);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : null;
    }
    numberTrackersOverThreshold() {
        const offset = this.bb.__offset(this.bb_pos, 24);
        return offset ? this.bb.readUint8(this.bb_pos + offset) : null;
    }
    static startTapDetectionSettings(builder) {
        builder.startObject(11);
    }
    static addFullResetDelay(builder, fullResetDelay) {
        builder.addFieldFloat32(0, fullResetDelay, 0);
    }
    static addFullResetEnabled(builder, fullResetEnabled) {
        builder.addFieldInt8(1, +fullResetEnabled, 0);
    }
    static addFullResetTaps(builder, fullResetTaps) {
        builder.addFieldInt8(2, fullResetTaps, 0);
    }
    static addYawResetDelay(builder, yawResetDelay) {
        builder.addFieldFloat32(3, yawResetDelay, 0);
    }
    static addYawResetEnabled(builder, yawResetEnabled) {
        builder.addFieldInt8(4, +yawResetEnabled, 0);
    }
    static addYawResetTaps(builder, yawResetTaps) {
        builder.addFieldInt8(5, yawResetTaps, 0);
    }
    static addMountingResetDelay(builder, mountingResetDelay) {
        builder.addFieldFloat32(6, mountingResetDelay, 0);
    }
    static addMountingResetEnabled(builder, mountingResetEnabled) {
        builder.addFieldInt8(7, +mountingResetEnabled, 0);
    }
    static addMountingResetTaps(builder, mountingResetTaps) {
        builder.addFieldInt8(8, mountingResetTaps, 0);
    }
    static addSetupMode(builder, setupMode) {
        builder.addFieldInt8(9, +setupMode, 0);
    }
    static addNumberTrackersOverThreshold(builder, numberTrackersOverThreshold) {
        builder.addFieldInt8(10, numberTrackersOverThreshold, 0);
    }
    static endTapDetectionSettings(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createTapDetectionSettings(builder, fullResetDelay, fullResetEnabled, fullResetTaps, yawResetDelay, yawResetEnabled, yawResetTaps, mountingResetDelay, mountingResetEnabled, mountingResetTaps, setupMode, numberTrackersOverThreshold) {
        TapDetectionSettings.startTapDetectionSettings(builder);
        if (fullResetDelay !== null)
            TapDetectionSettings.addFullResetDelay(builder, fullResetDelay);
        if (fullResetEnabled !== null)
            TapDetectionSettings.addFullResetEnabled(builder, fullResetEnabled);
        if (fullResetTaps !== null)
            TapDetectionSettings.addFullResetTaps(builder, fullResetTaps);
        if (yawResetDelay !== null)
            TapDetectionSettings.addYawResetDelay(builder, yawResetDelay);
        if (yawResetEnabled !== null)
            TapDetectionSettings.addYawResetEnabled(builder, yawResetEnabled);
        if (yawResetTaps !== null)
            TapDetectionSettings.addYawResetTaps(builder, yawResetTaps);
        if (mountingResetDelay !== null)
            TapDetectionSettings.addMountingResetDelay(builder, mountingResetDelay);
        if (mountingResetEnabled !== null)
            TapDetectionSettings.addMountingResetEnabled(builder, mountingResetEnabled);
        if (mountingResetTaps !== null)
            TapDetectionSettings.addMountingResetTaps(builder, mountingResetTaps);
        if (setupMode !== null)
            TapDetectionSettings.addSetupMode(builder, setupMode);
        if (numberTrackersOverThreshold !== null)
            TapDetectionSettings.addNumberTrackersOverThreshold(builder, numberTrackersOverThreshold);
        return TapDetectionSettings.endTapDetectionSettings(builder);
    }
    unpack() {
        return new TapDetectionSettingsT(this.fullResetDelay(), this.fullResetEnabled(), this.fullResetTaps(), this.yawResetDelay(), this.yawResetEnabled(), this.yawResetTaps(), this.mountingResetDelay(), this.mountingResetEnabled(), this.mountingResetTaps(), this.setupMode(), this.numberTrackersOverThreshold());
    }
    unpackTo(_o) {
        _o.fullResetDelay = this.fullResetDelay();
        _o.fullResetEnabled = this.fullResetEnabled();
        _o.fullResetTaps = this.fullResetTaps();
        _o.yawResetDelay = this.yawResetDelay();
        _o.yawResetEnabled = this.yawResetEnabled();
        _o.yawResetTaps = this.yawResetTaps();
        _o.mountingResetDelay = this.mountingResetDelay();
        _o.mountingResetEnabled = this.mountingResetEnabled();
        _o.mountingResetTaps = this.mountingResetTaps();
        _o.setupMode = this.setupMode();
        _o.numberTrackersOverThreshold = this.numberTrackersOverThreshold();
    }
}
exports.TapDetectionSettings = TapDetectionSettings;
class TapDetectionSettingsT {
    constructor(fullResetDelay = null, fullResetEnabled = null, fullResetTaps = null, yawResetDelay = null, yawResetEnabled = null, yawResetTaps = null, mountingResetDelay = null, mountingResetEnabled = null, mountingResetTaps = null, setupMode = null, numberTrackersOverThreshold = null) {
        this.fullResetDelay = fullResetDelay;
        this.fullResetEnabled = fullResetEnabled;
        this.fullResetTaps = fullResetTaps;
        this.yawResetDelay = yawResetDelay;
        this.yawResetEnabled = yawResetEnabled;
        this.yawResetTaps = yawResetTaps;
        this.mountingResetDelay = mountingResetDelay;
        this.mountingResetEnabled = mountingResetEnabled;
        this.mountingResetTaps = mountingResetTaps;
        this.setupMode = setupMode;
        this.numberTrackersOverThreshold = numberTrackersOverThreshold;
    }
    pack(builder) {
        return TapDetectionSettings.createTapDetectionSettings(builder, this.fullResetDelay, this.fullResetEnabled, this.fullResetTaps, this.yawResetDelay, this.yawResetEnabled, this.yawResetTaps, this.mountingResetDelay, this.mountingResetEnabled, this.mountingResetTaps, this.setupMode, this.numberTrackersOverThreshold);
    }
}
exports.TapDetectionSettingsT = TapDetectionSettingsT;
